var _clipPath, _image, _mask, _image2, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaurageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "206.25pt",
    height: "44.999999pt",
    viewBox: "0 0 206.25 44.999999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.546875 -6.96875 L 3.546875 0 L 2.765625 0 L 2.765625 -6.96875 L 0.65625 -6.96875 L 0.65625 -7.703125 L 5.671875 -7.703125 L 5.671875 -6.96875 Z M 3.546875 -6.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.21875 0 L 4.21875 -0.546875 C 3.71875 -0.0976563 3.167969 0.125 2.578125 0.125 C 1.984375 0.125 1.511719 -0.0351563 1.171875 -0.359375 C 0.828125 -0.679688 0.65625 -1.148438 0.65625 -1.765625 C 0.65625 -2.378906 0.851563 -2.84375 1.25 -3.15625 C 1.644531 -3.464844 2.128906 -3.625 2.703125 -3.625 C 3.222656 -3.625 3.726563 -3.492188 4.21875 -3.234375 L 4.21875 -3.703125 C 4.21875 -4.617188 3.804688 -5.078125 2.984375 -5.078125 C 2.460938 -5.078125 1.902344 -4.878906 1.3125 -4.484375 L 1.09375 -5.140625 C 1.738281 -5.542969 2.394531 -5.75 3.0625 -5.75 C 3.289063 -5.75 3.503906 -5.722656 3.703125 -5.671875 C 3.898438 -5.617188 4.097656 -5.523438 4.296875 -5.390625 C 4.492188 -5.253906 4.648438 -5.050781 4.765625 -4.78125 C 4.878906 -4.507813 4.9375 -4.183594 4.9375 -3.8125 L 4.9375 0 Z M 2.65625 -0.53125 C 3.226563 -0.53125 3.75 -0.820313 4.21875 -1.40625 L 4.21875 -2.5 C 3.757813 -2.800781 3.277344 -2.953125 2.78125 -2.953125 C 2.375 -2.953125 2.035156 -2.851563 1.765625 -2.65625 C 1.503906 -2.457031 1.375 -2.160156 1.375 -1.765625 C 1.375 -1.390625 1.484375 -1.085938 1.703125 -0.859375 C 1.929688 -0.640625 2.25 -0.53125 2.65625 -0.53125 Z M 2.65625 -0.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.40625 0 L 4.40625 -0.53125 C 4.207031 -0.289063 3.996094 -0.117188 3.78125 -0.015625 C 3.570313 0.0742188 3.308594 0.125 3 0.125 C 2.269531 0.125 1.742188 -0.078125 1.421875 -0.484375 C 1.097656 -0.886719 0.9375 -1.554688 0.9375 -2.484375 L 0.9375 -5.625 L 1.703125 -5.625 L 1.703125 -2.1875 C 1.703125 -1.632813 1.816406 -1.222656 2.046875 -0.953125 C 2.285156 -0.691406 2.601563 -0.5625 3 -0.5625 C 3.933594 -0.5625 4.40625 -1.097656 4.40625 -2.171875 L 4.40625 -5.625 L 5.171875 -5.625 L 5.171875 0 Z M 4.40625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 0 L 0.984375 -5.625 L 1.765625 -5.625 L 1.765625 -4.828125 C 2.042969 -5.441406 2.515625 -5.75 3.171875 -5.75 C 3.492188 -5.75 3.757813 -5.667969 3.96875 -5.515625 L 3.84375 -4.78125 C 3.625 -4.914063 3.382813 -4.984375 3.125 -4.984375 C 2.78125 -4.984375 2.464844 -4.835938 2.1875 -4.546875 C 1.90625 -4.253906 1.765625 -3.792969 1.765625 -3.171875 L 1.765625 0 Z M 0.984375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.578125 2.34375 L 2.21875 1.734375 C 3.058594 1.691406 3.640625 1.535156 3.953125 1.265625 C 4.273438 1.003906 4.4375 0.652344 4.4375 0.21875 L 4.4375 -0.640625 C 4.09375 -0.128906 3.582031 0.125 2.90625 0.125 C 2.257813 0.125 1.710938 -0.128906 1.265625 -0.640625 C 0.828125 -1.160156 0.609375 -1.882813 0.609375 -2.8125 C 0.609375 -3.726563 0.820313 -4.445313 1.25 -4.96875 C 1.683594 -5.488281 2.253906 -5.75 2.953125 -5.75 C 3.574219 -5.75 4.070313 -5.527344 4.4375 -5.09375 L 4.4375 -5.625 L 5.21875 -5.625 L 5.21875 -0.09375 C 5.21875 1.457031 4.335938 2.269531 2.578125 2.34375 Z M 3.078125 -0.5625 C 3.316406 -0.5625 3.566406 -0.644531 3.828125 -0.8125 C 4.085938 -0.988281 4.289063 -1.21875 4.4375 -1.5 L 4.4375 -4.203125 C 4.289063 -4.460938 4.082031 -4.671875 3.8125 -4.828125 C 3.550781 -4.980469 3.304688 -5.0625 3.078125 -5.0625 C 2.523438 -5.0625 2.105469 -4.867188 1.828125 -4.484375 C 1.546875 -4.097656 1.40625 -3.539063 1.40625 -2.8125 C 1.40625 -2.113281 1.5625 -1.558594 1.875 -1.15625 C 2.183594 -0.757813 2.585938 -0.5625 3.078125 -0.5625 Z M 3.078125 -0.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.046875 -6.671875 C 2.910156 -6.671875 2.789063 -6.71875 2.6875 -6.8125 C 2.582031 -6.914063 2.53125 -7.039063 2.53125 -7.1875 C 2.53125 -7.332031 2.578125 -7.453125 2.671875 -7.546875 C 2.773438 -7.648438 2.898438 -7.703125 3.046875 -7.703125 C 3.191406 -7.703125 3.3125 -7.648438 3.40625 -7.546875 C 3.507813 -7.453125 3.5625 -7.332031 3.5625 -7.1875 C 3.5625 -7.039063 3.507813 -6.914063 3.40625 -6.8125 C 3.3125 -6.71875 3.191406 -6.671875 3.046875 -6.671875 Z M 3.046875 0.125 C 2.316406 0.125 1.726563 -0.15625 1.28125 -0.71875 C 0.832031 -1.289063 0.609375 -1.988281 0.609375 -2.8125 C 0.609375 -3.726563 0.832031 -4.445313 1.28125 -4.96875 C 1.726563 -5.488281 2.316406 -5.75 3.046875 -5.75 C 3.691406 -5.75 4.222656 -5.519531 4.640625 -5.0625 C 5.054688 -4.601563 5.265625 -3.925781 5.265625 -3.03125 C 5.265625 -2.832031 5.257813 -2.652344 5.25 -2.5 L 1.421875 -2.5 C 1.480469 -1.90625 1.65625 -1.433594 1.9375 -1.09375 C 2.226563 -0.75 2.609375 -0.578125 3.078125 -0.578125 C 3.523438 -0.578125 3.945313 -0.722656 4.34375 -1.015625 L 4.765625 -0.5 C 4.253906 -0.0820313 3.679688 0.125 3.046875 0.125 Z M 1.390625 -3.1875 L 4.484375 -3.1875 C 4.484375 -3.871094 4.335938 -4.359375 4.046875 -4.640625 C 3.753906 -4.917969 3.417969 -5.0625 3.046875 -5.0625 C 2.578125 -5.0625 2.191406 -4.898438 1.890625 -4.578125 C 1.585938 -4.265625 1.417969 -3.800781 1.390625 -3.1875 Z M 1.390625 -3.1875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.578125 0.125 C 1.835938 0.125 1.191406 -0.195313 0.640625 -0.84375 L 1.171875 -1.3125 C 1.605469 -0.800781 2.097656 -0.546875 2.640625 -0.546875 C 2.960938 -0.546875 3.222656 -0.617188 3.421875 -0.765625 C 3.628906 -0.910156 3.734375 -1.109375 3.734375 -1.359375 C 3.734375 -1.523438 3.695313 -1.671875 3.625 -1.796875 C 3.550781 -1.917969 3.433594 -2.035156 3.28125 -2.140625 C 3.125 -2.253906 2.980469 -2.335938 2.859375 -2.390625 C 2.734375 -2.449219 2.558594 -2.53125 2.34375 -2.625 C 2.082031 -2.726563 1.863281 -2.820313 1.6875 -2.90625 C 1.519531 -2.996094 1.347656 -3.109375 1.171875 -3.234375 C 0.992188 -3.367188 0.863281 -3.523438 0.78125 -3.703125 C 0.695313 -3.886719 0.65625 -4.097656 0.65625 -4.328125 C 0.65625 -4.753906 0.820313 -5.097656 1.15625 -5.359375 C 1.496094 -5.617188 1.9375 -5.75 2.46875 -5.75 C 3.214844 -5.75 3.828125 -5.460938 4.296875 -4.890625 L 3.796875 -4.46875 C 3.390625 -4.871094 2.941406 -5.078125 2.453125 -5.078125 C 2.128906 -5.078125 1.867188 -5.007813 1.671875 -4.875 C 1.484375 -4.738281 1.390625 -4.554688 1.390625 -4.328125 C 1.390625 -4.222656 1.414063 -4.121094 1.46875 -4.03125 C 1.519531 -3.9375 1.578125 -3.855469 1.640625 -3.796875 C 1.699219 -3.734375 1.800781 -3.660156 1.9375 -3.578125 C 2.082031 -3.503906 2.191406 -3.445313 2.265625 -3.40625 C 2.347656 -3.375 2.484375 -3.320313 2.671875 -3.25 C 2.886719 -3.164063 3.0625 -3.089844 3.1875 -3.03125 C 3.308594 -2.976563 3.46875 -2.894531 3.65625 -2.78125 C 3.839844 -2.675781 3.984375 -2.566406 4.078125 -2.453125 C 4.179688 -2.335938 4.269531 -2.183594 4.34375 -2 C 4.425781 -1.820313 4.46875 -1.621094 4.46875 -1.40625 C 4.46875 -0.9375 4.292969 -0.558594 3.953125 -0.28125 C 3.609375 -0.0078125 3.148438 0.125 2.578125 0.125 Z M 2.578125 0.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.390625 -6.78125 C 1.253906 -6.78125 1.132813 -6.828125 1.03125 -6.921875 C 0.9375 -7.011719 0.890625 -7.132813 0.890625 -7.28125 C 0.890625 -7.425781 0.9375 -7.550781 1.03125 -7.65625 C 1.132813 -7.757813 1.253906 -7.8125 1.390625 -7.8125 C 1.535156 -7.8125 1.65625 -7.757813 1.75 -7.65625 C 1.851563 -7.550781 1.90625 -7.425781 1.90625 -7.28125 C 1.90625 -7.132813 1.851563 -7.011719 1.75 -6.921875 C 1.65625 -6.828125 1.535156 -6.78125 1.390625 -6.78125 Z M 0.015625 2.34375 L -0.328125 1.734375 C 0.566406 1.648438 1.015625 1.289063 1.015625 0.65625 L 1.015625 -5.625 L 1.78125 -5.625 L 1.78125 0.359375 C 1.78125 0.867188 1.675781 1.285156 1.46875 1.609375 C 1.164063 2.054688 0.679688 2.300781 0.015625 2.34375 Z M 0.015625 2.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.015625 0.125 C 2.273438 0.125 1.683594 -0.128906 1.25 -0.640625 C 0.820313 -1.160156 0.609375 -1.882813 0.609375 -2.8125 C 0.609375 -3.726563 0.828125 -4.445313 1.265625 -4.96875 C 1.699219 -5.488281 2.285156 -5.75 3.015625 -5.75 C 3.742188 -5.75 4.328125 -5.488281 4.765625 -4.96875 C 5.199219 -4.457031 5.421875 -3.738281 5.421875 -2.8125 C 5.421875 -1.894531 5.199219 -1.175781 4.765625 -0.65625 C 4.328125 -0.132813 3.742188 0.125 3.015625 0.125 Z M 3.015625 -0.5625 C 3.511719 -0.5625 3.90625 -0.757813 4.1875 -1.15625 C 4.476563 -1.558594 4.625 -2.113281 4.625 -2.8125 C 4.625 -3.519531 4.480469 -4.070313 4.203125 -4.46875 C 3.929688 -4.863281 3.535156 -5.0625 3.015625 -5.0625 C 2.492188 -5.0625 2.089844 -4.867188 1.8125 -4.484375 C 1.539063 -4.097656 1.40625 -3.539063 1.40625 -2.8125 C 1.40625 -2.101563 1.539063 -1.550781 1.8125 -1.15625 C 2.089844 -0.757813 2.492188 -0.5625 3.015625 -0.5625 Z M 3.015625 -0.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.453125 0 L 4.453125 -3.4375 C 4.453125 -3.996094 4.332031 -4.410156 4.09375 -4.671875 C 3.863281 -4.929688 3.542969 -5.0625 3.140625 -5.0625 C 2.222656 -5.0625 1.765625 -4.523438 1.765625 -3.453125 L 1.765625 0 L 0.984375 0 L 0.984375 -5.625 L 1.765625 -5.625 L 1.765625 -5 C 2.105469 -5.496094 2.59375 -5.75 3.21875 -5.75 C 3.902344 -5.75 4.410156 -5.539063 4.734375 -5.125 C 5.054688 -4.707031 5.21875 -4.035156 5.21875 -3.109375 L 5.21875 0 Z M 4.453125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.5 0 L 0.4375 -5.625 L 1.234375 -5.625 L 2.59375 -1.796875 C 2.613281 -1.753906 2.632813 -1.691406 2.65625 -1.609375 C 2.675781 -1.535156 2.695313 -1.460938 2.71875 -1.390625 C 2.746094 -1.328125 2.773438 -1.261719 2.796875 -1.203125 C 2.816406 -1.261719 2.835938 -1.328125 2.859375 -1.390625 C 2.878906 -1.460938 2.898438 -1.535156 2.921875 -1.609375 C 2.949219 -1.691406 2.972656 -1.753906 2.984375 -1.796875 L 4.328125 -5.625 L 5.09375 -5.625 L 3.03125 0 Z M 2.5 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.75 -6.921875 C 1.65625 -6.828125 1.535156 -6.78125 1.390625 -6.78125 C 1.242188 -6.78125 1.117188 -6.828125 1.015625 -6.921875 C 0.921875 -7.011719 0.875 -7.132813 0.875 -7.28125 C 0.875 -7.425781 0.921875 -7.550781 1.015625 -7.65625 C 1.117188 -7.757813 1.242188 -7.8125 1.390625 -7.8125 C 1.535156 -7.8125 1.65625 -7.757813 1.75 -7.65625 C 1.839844 -7.550781 1.890625 -7.425781 1.890625 -7.28125 C 1.890625 -7.132813 1.839844 -7.011719 1.75 -6.921875 Z M 1 0 L 1 -5.625 L 1.765625 -5.625 L 1.765625 0 Z M 1 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.046875 0 L 1.046875 -7.5625 L 1.8125 -7.9375 L 1.8125 0 Z M 1.046875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.921875 0.125 C 2.203125 0.125 1.632813 -0.140625 1.21875 -0.671875 C 0.8125 -1.199219 0.609375 -1.914063 0.609375 -2.8125 C 0.609375 -3.726563 0.8125 -4.445313 1.21875 -4.96875 C 1.632813 -5.488281 2.203125 -5.75 2.921875 -5.75 C 3.480469 -5.75 3.984375 -5.570313 4.421875 -5.21875 L 4.421875 -7.5625 L 5.1875 -7.9375 L 5.1875 0 L 4.421875 0 L 4.421875 -0.484375 C 4.015625 -0.078125 3.511719 0.125 2.921875 0.125 Z M 3.015625 -0.5625 C 3.292969 -0.5625 3.5625 -0.632813 3.8125 -0.78125 C 4.058594 -0.933594 4.265625 -1.15625 4.421875 -1.4375 L 4.421875 -4.25 C 4.085938 -4.789063 3.617188 -5.0625 3.015625 -5.0625 C 2.503906 -5.0625 2.105469 -4.863281 1.828125 -4.46875 C 1.546875 -4.082031 1.40625 -3.527344 1.40625 -2.8125 C 1.40625 -2.164063 1.550781 -1.628906 1.84375 -1.203125 C 2.132813 -0.773438 2.523438 -0.5625 3.015625 -0.5625 Z M 3.015625 -0.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.65625 2.140625 L 2.5 -0.171875 L 0.4375 -5.625 L 1.21875 -5.625 L 2.640625 -1.625 C 2.660156 -1.550781 2.691406 -1.445313 2.734375 -1.3125 C 2.785156 -1.1875 2.816406 -1.101563 2.828125 -1.0625 L 3.03125 -1.625 L 4.46875 -5.625 L 5.296875 -5.625 L 2.421875 2.140625 Z M 1.65625 2.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.328125 0.125 C 3.078125 0.125 2.847656 0.0859375 2.640625 0.015625 C 2.429688 -0.0546875 2.269531 -0.128906 2.15625 -0.203125 C 2.050781 -0.273438 1.917969 -0.375 1.765625 -0.5 L 1.765625 0 L 0.984375 0 L 0.984375 -7.5625 L 1.765625 -7.9375 L 1.765625 -5.078125 C 1.941406 -5.273438 2.164063 -5.4375 2.4375 -5.5625 C 2.707031 -5.683594 2.976563 -5.75 3.25 -5.75 C 3.964844 -5.75 4.535156 -5.488281 4.953125 -4.96875 C 5.367188 -4.445313 5.578125 -3.726563 5.578125 -2.8125 C 5.578125 -1.863281 5.378906 -1.132813 4.984375 -0.625 C 4.585938 -0.125 4.035156 0.125 3.328125 0.125 Z M 3.203125 -0.5625 C 3.722656 -0.5625 4.113281 -0.757813 4.375 -1.15625 C 4.644531 -1.550781 4.78125 -2.101563 4.78125 -2.8125 C 4.78125 -3.539063 4.644531 -4.097656 4.375 -4.484375 C 4.113281 -4.867188 3.722656 -5.0625 3.203125 -5.0625 C 2.890625 -5.0625 2.601563 -4.964844 2.34375 -4.78125 C 2.082031 -4.601563 1.886719 -4.410156 1.765625 -4.203125 L 1.765625 -1.4375 C 1.910156 -1.175781 2.113281 -0.960938 2.375 -0.796875 C 2.644531 -0.640625 2.921875 -0.5625 3.203125 -0.5625 Z M 3.203125 -0.5625 "
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2 L 108.75 2 L 108.75 43.644531 L 0 43.644531 Z M 0 2 "
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image7",
    width: 180,
    height: 69,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAABFCAAAAADGaJNSAAAAAmJLR0QA/4ePzL8AAAeMSURBVGiB7Zl7bBTXFca/3o5Wq9XKWq1W1sqajLeW1QaXGNdyXQshi7oOIcQxKHGAIEoNpQmNiJS2NGoQoUIWqlpkEQtRmiJEKEGBpi6gyhACTgKBEFoeDhBMiAFjb9Zv/GC99np25vSPmTsPs3htU7wr1d8/e+fbc+/85ujMnbl3gGlNa1rT+r/Rt81mxmNDI+Pu5/iON6w8Ap4JyTN/5+3BM6/PFMYVLVXW9fYcXi4+Yqixlb7lSpSIiHqOrUpIkla+t1UhIlLu7J45FXQP0DwypLS9V+56cCQrqvk6akavmzrG+2SBJiK5tabQES9MyP7dF1FbaOpAE5Hyxfocpz1GyFj9cXR0XNKhFVmx8gweXxMwb0v/c+912K5KUZIHzbFUlUFQVYDxf1ylpe2n3j/dDsCd/2JpFrP0UlXGoKoMydTMCzLPoD3d8s23Swo2XRqyJVlW9BjlZnkyqd1ztrUZoHbuoX57WfDLo3u1i7zJzTXgLK/t4Rm0cpuURiUT0eDJ1b5kE2vyr67vNfEUO7RiVs7gpQ05yWa1iM1cf27Qzq1Bm8RyY02xM/FIUyv3nOpGDqjICimyJe3UtrcsPdmE8eVbsKfLSHd0yCzkukopNQo5rlj68mNRIiJZUaKyViBX1mXFfbinlMTXvlQUraYVuW1LXrJy7JobmMipV5mzx75HxpRI7qPUU2q3UrhEdeXMgfcFu5X60MEQYhfs1viWV8lU6IXnv/673Up9aFy+PNpJ/fKIo8lmWsiQArgRCqmAO7u5DwCY32fmhPnTG7RWWvb1iOAXA6eD+l++jOy0UHMwAggSazJ6+DKy00K3QhFACMC0nWJADDcFu8dN9sApjxUfaFOIlNbdhe715zpyASB31+1/GQF5u+9oB54N5zqk2XtalWiJ9o9U9WWUiPrrl7nLarte5x3EzY1RIuqtX+4qr+3aaCAvPd5LRNHGP2Y9LLT7D8Y7ds/2KPXnAsBrRCb0ZqI6AEDBPbq3rYeIBucAACv7ir8TRA9fItKhWVkjGfYVIg7tP2ysSm8/Z55/MuXhqlkhAAPtEF3wrkl4V7hfYUD41gAAVLztAWLBYW86HOWqEVKxwxvPzqgtAtDd7RQFBPa4/8b9SdyI7NeVAppWZj7xROarwfEMwNDyy8d+eBVA3g4Pht+aMWNW5o8/Uc2u+du8iLz1/RmzMp88YbGdO4qgnno6c9aM7/0pDPfW2ePCi18euT1En/q1dvZ/iBKVB9HZgE5/nKirTCfaKpNeHs46ot4Ful0tEy+PFTIpO/SNo9IOonr3pKFZNVFrgB/ldSSG/oZvnhXKFH2JJ9J9kEMXRklezXu6DnJo10mi48Zm1zKFhko4wnjgbXLOB7Y386OG/Yl7vHtVbzwr4PJ+XrLhrWFuO9BgPPMi1RG9lZUHtYofYP9FOJ/R2xO/Eb1ZGD5iHh58JdEQI3W8VQh8OGD4DbdytUaezT7f8rjWyE4Dqs27UgJyHSOThXYgfNc8DMYSDTF8i7f8UO+YfqRT+2UicNsS3vm4QckKbCOlOzXoiZdHTIVg6WVtm03bytfIVgzMsvYx2iO23DHBtEdLP8HEM90Z9qRltxiH+XyEMCAxnY/F32G4no8fMOMSfJL2q14rxI/+atge3cY1lam/6bP274tMFnrgYglbeSqmHzl+ytPbPOKQRP1iAgXxeuLTZSjNMl4r5vPt+7OVmCc1c3uRnw8YEtnIO/HGmXh5jBxQUbGId181l/tXg3C/rA0n/Mobt+uhPkhv8kks5w2esA86kbHZeZ8dOgG8MfFPDfEfLr4LRD3LBQBwrO01Hi6smqh/BQMgrB0kyzzdn2F03Uwk7/IBAAovEZ+nWRWRwu0LZDxcCrqIrhQDALxbKx8OGqW9RNGPXyotXXtWJgMa4k2iodqlcxdrbznxoD1niJSbVWVzF++5RwY0fCe5vVd7E9Og2TqZqP/AspIFG79ShpY+HDQq+FYOEfUqHBrFpq3Eh4Z0xtzZjA4ab3mjbf0tj22yfHo4a34JmtTK5R/PnNbno+EPfmbOTKeePa/dn7HP/vmAni0L/6LP8eqNlz+z2H/u4/YvLhq2+vuf39BnlYF3FhoPx0muXP791Lznc3xov1z7SXrIEebcnz+5aOF33cPXaw+tKYK21hgJuQZUS8/uV3cumS06BpqOHur8SRBhw969pEgUwk1HD7WvtIS/e6L86ey0WOjz989bRxlLY27WuEXRBUCQJNH6xPBKPgZ4JEnbp3SIkjg6MYJf8jIA6ZKUNsoGgHqiDRabeST/qO24ya/Gw1qWYi02V717FwD6+ENhJIj7FGvXfjvj2swJRCy22teHUUq91bgvgNiNsUNSD3qxH91Xxw5JFWgXn9Dyf8vwUfPYwSkCnbZ9VwAAhHn7JNzdkiA6NbbFPNuXstlHTkb8C4vdUDc1PMxYU7Y/7Ttmnim68eESOXWb6u4qfftHaSxPzJwoQlUZU1X2qEs//ObOiqdE58C1g0ciiaPH1OJ+/cOnPFTzP2GbCrn0T4rf7CvzJZvFqm8l+N9XuMRb+1FwvG8rqSKW+h8PpzWtaU1rfPov1SROErFWGREAAAAASUVORK5CYII="
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7",
    transform: "matrix(1,0,0,1,0,-0.000000000000000164)"
  }))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "image6",
    width: 180,
    height: 69,
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 206.25,
    height: 44.999999,
    style: {
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 0 L 206.25 0 L 206.25 45 L 0 45 Z M 0 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 0 L 206.25 0 L 206.25 45 L 0 45 Z M 0 0 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6",
    mask: "url(#mask0)",
    transform: "matrix(0.604167,0,0,0.608696,0,1.643179)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 120.178457,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 126.459466,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 132.128751,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 138.245908,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 142.40776,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 148.077045,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 154.237886,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 160.016409,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 165.073982,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 167.586386,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 171.748238,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 177.417523,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 180.170239,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-11",
    x: 186.15631,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 192.273467,
    y: 19.221661
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 120.178457,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 125.236029,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-12",
    x: 130.905314,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-13",
    x: 136.399829,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-12",
    x: 139.152546,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 144.647061,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-14",
    x: 150.316346,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-15",
    x: 153.156453,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-16",
    x: 159.295446,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-17",
    x: 164.986578,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 171.125571,
    y: 30.695844
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.548828%,12.548828%,12.548828%)",
      fillOpacity: 1
    },
    d: "M 112.269531 38.941406 L 112.269531 2.878906 L 111.503906 2.878906 L 111.503906 42.117188 L 112.269531 42.117188 Z M 112.269531 38.941406 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurageLogo);
export default __webpack_public_path__ + "static/media/taurage_logo.cd9d5388b83085b395b139b8dacfc6d1.svg";
export { ForwardRef as ReactComponent };